import React from 'react';
import {
  Switch,
} from 'react-router-dom';
import TagListLayout from './TagListLayout/TagListLayout';
import RaaRoute from '../../../common/RaaRoute';

function TagsPage() {
  /* istanbul ignore next */
  return (
    <Switch>
      <RaaRoute path="/s/guidance/tags" exact>
        <TagListLayout />
      </RaaRoute>
    </Switch>
  );
}

export default TagsPage;
